import {convertTime} from "./convertTime";

export function timeRangeConvert(range, zone = "local", separator = " - ") {
    if (!range) return "";
    return String(range)
        .split(",")
        .map((s) => convertTime(s, zone))
        .filter(Boolean)
        .join(separator);
}

export default timeRangeConvert;